export const constant = {
  New_HMI: 'New HMI',
  HMI_Name: 'HMI Name',
  HMI_Type: 'HMI Type',
  HMI_ID: 'Id',
  File_Name: 'File Name',
  Path: 'Path'
};
